'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'deer';
var width = 512;
var height = 512;
var aliases = [129420];
var unicode = 'f78e';
var svgPathData = 'M240 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 24c0 26.5 21.5 48 48 48l24 0 8 0 6.1 0-41.5 20.7c-7.7 3.9-12.6 11.8-12.6 20.4c0 12.6 10.2 22.8 22.8 22.8l33.2 0 6.5 0-11.3 32L112 176s0 0 0 0l-24 0c-48.6 0-88 39.4-88 88l0 48c0 4.4 3.6 8 8 8s8-3.6 8-8l0-48c0-39.8 32.2-72 72-72l24 0s0 0 0 0l200.9 0c3.4 0 6.4-2.1 7.5-5.3l15-42.7 .6 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-6.2 0L312 128l-33.2 0c-3.8 0-6.8-3.1-6.8-6.8c0-2.6 1.5-5 3.8-6.1l51-25.5c12.6-6.3 26.4-9.5 40.4-9.5c24 0 47 9.5 63.9 26.5l57.2 57.2c4.9 4.9 7.6 11.5 7.6 18.3c0 14.3-11.6 25.9-25.9 25.9L400 208c-3.6 0-6.8 2.4-7.7 5.9L370 295.7c-1.3 4.8-2 9.8-2 14.7L368 480c0 8.8-7.2 16-16 16l-40 0c-8.8 0-16-7.2-16-16l0-128c0-4.4-3.6-8-8-8l-24.3 0c-29.1 0-57.3-9.9-80-28l-2.7-2.2c-2.6-2.1-6.2-2.3-9-.7s-4.4 4.9-3.8 8.2l3.6 21.6c2.2 13-3.5 26-14.4 33.3c-18.2 12.1-26.3 34.8-19.8 55.7l13.4 43.4c3.2 10.3-4.5 20.7-15.3 20.7l-37.8 0c-7 0-13.2-4.6-15.3-11.3L60.2 412.3c-2.5-8-2.4-16.5 .3-24.4l8.8-26.3c1.8-5.5 2.8-11.2 2.8-17c0-18-9-34.8-24-44.8l-4.2-2.8C39 293.7 35 289.5 32 284.7l0 23.4c1 .7 1.9 1.4 3 2.1l4.2 2.8c10.5 7 16.9 18.9 16.9 31.5c0 4.1-.7 8.1-1.9 12l-8.8 26.3c-3.7 11.1-3.8 23-.4 34.2l22.3 72.4C71.3 502.8 83.7 512 97.7 512l37.8 0c21.5 0 36.9-20.8 30.6-41.4l-13.4-43.4c-4.4-14.1 1.1-29.4 13.4-37.7c16.2-10.8 24.5-30.1 21.3-49.3l-.4-2.3C210 352.3 236.5 360 263.7 360l16.3 0 0 120c0 17.7 14.3 32 32 32l40 0c17.7 0 32-14.3 32-32l0-169.6c0-3.6 .5-7.1 1.4-10.5L406.1 224l63.9 0c23.2 0 41.9-18.8 41.9-41.9c0-11.1-4.4-21.8-12.3-29.7L442.5 95.2c-5.8-5.8-12.2-10.9-19.1-15.2l.6 0c26.5 0 48-21.5 48-48l0-24c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 24c0 17.7-14.3 32-32 32l-8 0-48.8 0-27.5 0c7.6-8.5 12.2-19.7 12.2-32l0-24c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 24c0 17.7-14.3 32-32 32l-8 0-24 0c-17.7 0-32-14.3-32-32l0-24zM416 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDeer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;